;(function () {
    function FilterShowButton(filterContainer) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        var showButton = $(filterContainer).find('[rel="search-filters--show-button"]');

        this.toggleOpenClasses = function () {
            if(filterContainer) {
                filterContainer.classList.toggle('filters--show');
            }
        }

        /**
         * set events and open if filters already set
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            $(showButton).click(this.toggleOpenClasses);
            var lastOpenedBucket = localStorage.getItem('lastOpenedBucket')
            if (lastOpenedBucket) {
                this.toggleOpenClasses();
            }
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.FilterShowButton = window.FilterShowButton || {}

    window.FilterShowButton.FilterShowButton = FilterShowButton
})()

$(document).ready(function () {
    var showButtonContainer = $('[rel="search-filters--container"]')

    if (showButtonContainer) {
        new window.FilterShowButton.FilterShowButton(showButtonContainer[0])
    }
})
